module.exports = __webpack_public_path__ + "static/img/ad2.5557043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad2.png
// module id = DKmO
// module chunks = 12